export const isEmptyObj = (object) => {
  for (const property in object) {
    return false;
  }
  return true;
};

export const isSmartedit = () => {
  if (typeof smartedit === "object") return smartedit.hasOwnProperty("domain");
  return false;
};

export const isBoolean = (val) => "boolean" === typeof val;

export const getBasePath = () => `/${window.location.pathname.split("/")[1]}`;

export const getBaseApiPath = (c) => `${getBasePath()}/api/c/${c}`;
